import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFormValidation from '../../../hooks/useFormValidation';
import useDeregisterAvisoObraFieldsConfig from './useDeregisterAvisoObraFieldsConfig';

export interface DeregisterAvisoObraFormData {
    extensionDate: string;
    observation: string;
}

export const INITIAL_VALUES: DeregisterAvisoObraFormData = {
    extensionDate: '',
    observation: ''
};

const useDeregisterAvisoObraForm = () => {
    const [formData, setFormData] = useState<DeregisterAvisoObraFormData>(INITIAL_VALUES);
    const { t } = useTranslation('avisoObra');

    const { errors, hasValidationErrors, validateForm, handleBlurValidation, setErrors } =
        useFormValidation();

    const { fieldsConfig } = useDeregisterAvisoObraFieldsConfig({
        t,
        formData,
        handleBlurValidation
    });

    const handleChange = (name: string, value: any) => {
        setErrors((prevState) => ({
            ...prevState,
            [name]: { hasError: false, errorMessage: '' }
        }));
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const resetForm = () => {
        setFormData(INITIAL_VALUES);
        setErrors({});
    };
    return {
        formData,
        errors,
        hasValidationErrors,
        fieldsConfig,
        handleChange,
        validateForm,
        resetForm
    };
};

export default useDeregisterAvisoObraForm;
